import { Path } from "@common/constans";
import { IAirCheckinRequest, IOriginDestination, IPnrInfo } from "@common/models";
import Divider from "@components/general/Divider";
import Button from "@components/general/form/Button";
import Icon from "@components/general/Icon";
import { AppAction, IAppAction } from "@misc/Action";
import { Action, getCheckinInfo } from "@service/proxy";
import Translate from "@service/Translate";
import { formatToDate, formatToDateTime, getAirport } from "@utilize/Format";
import { FC, Fragment } from "react";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router";

interface ICurrentTripsProps {
    pnrInfo: IPnrInfo[];
}

const UpComingCheckIn: FC<ICurrentTripsProps> = ({ pnrInfo }) => {
    const tr = Translate.tr;
    const dispatch = useDispatch();
    const { push } = useHistory();


    const onOnlineCheckInClick = (pnrItem: IPnrInfo, od: IOriginDestination): Promise<boolean> => {
        return new Promise((resolve) => {
            const checkinRequest: IAirCheckinRequest = {
                referenceId: pnrItem.pnr,
                flightNumber: od.flightSegments[0].flightNumber
            };
            getCheckinInfo(Action.POST, { data: checkinRequest })
                .then((response) => {
                    dispatch<IAppAction>({
                        type: AppAction.AirCheckinRequest,
                        payload: { airCheckinRequest: checkinRequest },
                    });
                    dispatch<IAppAction>({
                        type: AppAction.AirCheckinInfo,
                        payload: { airCheckinInfo: response.content },
                    });
                    push(Path.Checkin.SelectPassenger);
                })
                .catch((err) => { })
                .finally(() => resolve(true));
        })
    }

    return (
        <div className="upcoming-check-in">
            {
                pnrInfo.map(pnrInfoItem => pnrInfoItem.originDestinations?.map((od, index) => {
                    return (
                        <Fragment key={index}>
                            <div className="row flex flex-center upcoming-check-in-item">
                                <div className="col-1-5 col-md-1-4 col-sm-1-auto upcoming-check-in-item-cell">
                                    <div className="row spa-2 flex flex-no-wrap flex-center">
                                        <div className="col-1-auto upcoming-check-in-leg-route">
                                            <span className="origin">{getAirport(od.origin.code).cityName}</span>
                                            <Icon name="icon-airplane" flipRtl />
                                            <span className="destination">{getAirport(od.destination.code).cityName}</span>
                                        </div>
                                        <div className="upcoming-check-in-collapse-gradient" />
                                    </div>
                                </div>
                                <div className="col-1-5 col-md-1-4 col-sm-1-auto upcoming-check-in-item-cell flight-number-item">
                                    <span className="upcoming-check-in-item-cell-title">{tr("flight_no")}: </span>
                                    <span className="upcoming-check-in-item-cell-content flight-number">
                                        <span className="flight-owner">{od.flightSegments[0].flightNumber?.substring(0, 2)}</span>
                                        <span className="b">{od.flightSegments[0].flightNumber?.substring(2) || ""}</span>
                                    </span>
                                </div>
                                <div className="col-1-5 col-md-1-4 col-sm-1-1 upcoming-check-in-item-cell">
                                    <span className="upcoming-check-in-item-cell-title">{tr("flight_date")}: </span>
                                    <span className="upcoming-check-in-item-cell-content">{od.departureDateTime ? formatToDate(od.departureDateTime) : ""}</span>
                                </div>
                                <div className="col-1-5 col-md-1-4 col-sm-1-1 upcoming-check-in-item-cell flight-hour">
                                    <span className="upcoming-check-in-item-cell-title">{tr("hour")} {tr("flight")}: </span>
                                    <span className="upcoming-check-in-item-cell-content">{od.departureDateTime ? formatToDateTime(od.departureDateTime, { format: "H:i" }) : ""}</span>
                                </div>
                                <div className="col-1-5 col-md-1-4 col-sm-1-auto upcoming-check-in-item-cell flex">
                                    <Button
                                        text={tr("checkin_seat_select")}
                                        variant="outlined"
                                        onClickAsync={() => onOnlineCheckInClick(pnrInfoItem, od)}
                                        disabled={!pnrInfoItem.pnr}
                                        height="35px"
                                    />
                                </div>
                            </div>
                            <Divider mode="perforation" orientation="horizontal" />
                        </Fragment>
                    )
                })
                )
            }
        </div>
    )
}

export default UpComingCheckIn;